/* stylelint-disable-next-line block-no-empty */
.block {
}

.form {
  display: flex;
  flex-direction: column;
}

.field {
  display: flex;
  flex-flow: column;
  min-height: 90px;
}

.input,
.numberInput {
  font-size: 1rem;
  border: 1px solid var(--grey) Light;
  border-radius: 5px;
  padding: 10px;
  background-color: var(--color-ffffff);
  max-width: 100%;
}

.input:focus,
.numberInput:focus {
  outline: 0;
  border-color: var(--primary-100);
}

.label {
  font-size: 1rem;
  padding-bottom: 0.25rem;
  color: var(--text);
  font-weight: 600;
}

.labelCheckbox {
  font-size: 1rem;
  padding-bottom: 0.25rem;
  color: var(--text);
  font-weight: 600;
}

.verticalLine {
  border: solid var(--text);
  border-width: 1px 0 0 0;
  margin: 20px 50px;
}

.inputSearch {
  display: flex;
  flex-direction: row;
  color: var(--text);
  border: 2px solid var(--primary-60);
  border-radius: 15px;
  background-color: var(--color-ffffff);
}

.inputSearch:focus-within,
.numberInput:focus-within {
  border-color: var(--primary-100);
}

.inputSearch .input {
  flex: 1;
  border: none;
  padding: 10px;
}

.inputSearch .icon {
  padding: 10px 0 10px 10px;
}

.inputSearch .searchButton {
  height: 100%;
  padding: 0 15px 0 15px;
}

.checkbox i {
  font-size: 2rem;
  color: var(--primary-60);
  text-align: end;
}

.inputSearch .searchButton > i {
  font-size: 1rem;
}

.clearableWrapper > * {
  display: flex;
  min-height: unset;
}

.clearButton {
  margin-left: 15px;
  margin-right: 15px;
  cursor: pointer;
}

.clearButton[disabled] {
  cursor: not-allowed;
}

.realCheckbox * {
  cursor: pointer;
}

.realCheckbox:checked {
  background-color: blueviolet;
}

.checkbox * {
  cursor: pointer;
}

.checkbox {
  margin-top: 5px;
}

.realCheckbox.disabled * {
  cursor: default;
}

.checkbox.disabled * {
  cursor: default;
}

.checkbox .input {
  display: none;
}

.inputDiv {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 2px;
}

.inputDiv input {
  width: 100%;
}

.select .inputDiv {
  display: flex;
  border: 2px solid var(--primary-60);
  border-radius: 15px;
  position: relative;
  background: var(--color-ffffff);
}

.autocomplete .inputDiv {
  display: flex;
  border: 1px solid var(--secondary-100);
  border-radius: 5px;
  position: relative;
}

.autocomplete .inputDiv:focus-within {
  border-color: var(--primary-100);
}

.autocomplete .inputDiv .inputSearch {
  flex: 1;
  border: none;
}

.autocomplete .inputDiv button {
  border: none;
  background-color: inherit;
  font-size: 1rem;
  border-radius: 10px;
}

.menu {
  position: absolute;
  border: 1px solid var(--primary-100);
  border-radius: 5px;
  background-color: white;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  font-size: 1rem;
  margin-top: 10px;
  max-height: 300px;
  overflow: auto;
}

.menu .item {
  padding: 15px 15px;
  min-height: 50px;
}

.menu .item.isActive {
  background-color: var(--primary-100);
}

.menu .item.isSelected {
  background-color: var(--primary-100);
}

.inputDiv.disabled,
.inputSearch.disabled,
.input:disabled {
  background-color: var(--grey);
  color: var(--color-ffffff);
  border-color: var(--color-ffffff);
}

.errorMessage {
  padding: 5px;
  font-size: 0.85rem;
  color: var(--color-c2436f);
}

.error .input,
.error .numberInput,
.error .inputSearch:not(.disabled) {
  border-color: var(--color-c2436f);
  color: var(--color-c2436f);
}

.autocomplete.error .inputDiv {
  border-color: var(--color-c2436f);
}

.noLabel {
  /*min-height: 70px;*/
}

.title {
  font-weight: bold;
  margin: 0.8rem 0;
}

.select .inputDiv:focus-within {
  border-color: var(--primary-100);
}

.select .inputDiv .inputSearch,
.select .inputDiv .input {
  flex: 1;
  border: none;
  background: var(--primary-30);
}

.select .inputDiv button {
  border: none;
  background-color: inherit;
  font-size: 1rem;
  border-radius: 15px;
}

.notResolved {
  padding: 20px 0;
}

.valueField {
  display: flex;
  flex-direction: row;
  color: var(--text);
  border: 1px solid var(--grey) Light;
  border-radius: 5px;
  background-color: var(--color-ffffff);
}

.value {
  font-size: 1rem;
  border-radius: 5px;
  padding: 10px;
  background-color: var(--color-ffffff);
}

/* pour idientifer le select */
/* stylelint-disable-next-line block-no-empty */
.reactSelect {
}

.reactSelect :global(.select__control--is-focused) {
  border: 1px solid var(--primary-60);
  box-shadow: none;
}

.reactSelect :global(.select__control) {
  border: 2px solid var(--primary-60);
  border-radius: 15px;
  padding: 5px;
}

.reactSelect :global(.select__single-value),
.reactSelect :global(.select__option) {
  color: var(--text);
}

.reactSelect :global(.select__option--is-selected),
.reactSelect :global(.select__option--is-focused) {
  color: var(--color-ffffff);
  background-color: var(--primary-100);
}

/* stylelint-disable-next-line block-no-empty */
.invalide {
}

/* stylelint-disable-next-line block-no-empty */
.clearableLine {
}

.textInput {
  font-size: 1rem;
  border: 1px solid var(--grey) Light;
  border-radius: 5px;
  padding: 10px;
  background-color: var(--color-ffffff);
  color: var(--text);
}

.largeTextInput {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 2px solid var(--primary-40);
  border-radius: 15px;
  color: var(--text);
  font:
    normal normal 300 1rem Roboto,
    sans-serif;
  margin: 10px 0 25px 0;
  width: 100%;
  padding: 18px;
}

.fileInputButton {
  display: flex;
  cursor: pointer;
  color: var(--text);
  width: 100%;
  border: 2px solid var(--primary-40);
  border-radius: 15px;
  padding: 18px;
  margin: 10px 0 25px 0;
  font:
    normal normal 300 1rem Roboto,
    sans-serif;
  align-items: center;
  justify-content: space-between;
}

.fileInputIcon {
  color: var(--primary-60);
  font-size: 1rem;
  cursor: pointer;
  position: relative;
}

.multiCbCheckbox {
  display: inline-flex;
  font-size: 1rem;
  margin-right: 15px;
  padding: 8px;
  font-weight: 600;
  border-radius: 5px;
  background: var(--grey) Light;
  color: var(--color-ffffff);
  cursor: pointer;
  transition: 0.3s;
}

.multiCbCheckbox.disabled {
  cursor: default;
}

.multiCbCheckboxActive,
.multiCbCheckbox:hover {
  background: var(--primary-100);
}

.multiCbCheckbox input {
  display: none !important;
}

.legende {
  color: var(--primary-100);
  font-style: italic;
  display: flex;
  justify-content: end;
}

.obligatoire {
  color: var(--color-c2436f);
  font-size: 1.5rem;
  font-weight: 600;
}
